export const SET_DATA_DAILY_SHARE = 'audiences/SET_DATA_DAILY_SHARE';
export const SET_DATA_RANKING = 'audiences/SET_DATA_RANKING';
export const SET_DATA_MONTHLY_SHARE = 'audiences/SET_DATA_MONTHLY_SHARE';
export const SET_DATA_DAILY_REPORTS = 'audiences/SET_DATA_DAILY_REPORTS';
